import { Component } from '@theme/component';

class EmeCarouselArrows extends Component {
  requiredRefs = ['previous', 'next'];
  #slideshow = null;
  #scroller = null;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#slideshow = this.closest('.shopify-section')?.querySelector('slideshow-component:is(.resource-list__carousel, .carousel-content)');
    if (!this.#slideshow) {
      this.hidden = true;
      return;
    }
    this.hidden = false;
    this.#scroller = this.#slideshow.querySelector('slideshow-slides');
    this.#slideshow.addEventListener('slideshow:select', this.#schedule);
    this.#slideshow.addEventListener('focusin', this.#reveal);
    this.#scroller?.addEventListener('scroll', this.#schedule, { passive: true });
    window.addEventListener('resize', this.#schedule, { passive: true });
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#slideshow?.removeEventListener('slideshow:select', this.#schedule);
    this.#slideshow?.removeEventListener('focusin', this.#reveal);
    this.#scroller?.removeEventListener('scroll', this.#schedule);
    window.removeEventListener('resize', this.#schedule);
    cancelAnimationFrame(this.#frame);
    this.#scroller = null;
    this.#slideshow = null;
  }

  previous(event) {
    if (this.refs.previous.getAttribute('aria-disabled') === 'true') return;
    this.#slideshow?.previous(event);
  }

  next(event) {
    if (this.refs.next.getAttribute('aria-disabled') === 'true') return;
    this.#slideshow?.next(event);
  }

  #reveal = (event) => {
    const slideshow = this.#slideshow;
    if (!slideshow || !(event.target instanceof Element) || !event.target.matches(':focus-visible')) return;
    const slide = slideshow.slides?.find((item) => item.contains(event.target));
    if (!slide || slide.getAttribute('aria-hidden') !== 'true') return;
    slideshow.select(slideshow.slides.indexOf(slide), undefined, { animate: false });
  };

  #schedule = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(this.#sync);
  };

  #sync = () => {
    const scroller = this.#scroller;
    if (!scroller) return;
    const position = Math.abs(scroller.scrollLeft);
    const atStart = position <= 1;
    const atEnd = position + scroller.clientWidth >= scroller.scrollWidth - 1;
    this.refs.previous.setAttribute('aria-disabled', String(atStart));
    this.refs.next.setAttribute('aria-disabled', String(atEnd));
  };
}

if (!customElements.get('eme-carousel-arrows')) customElements.define('eme-carousel-arrows', EmeCarouselArrows);
